import type { ModulesAndAgendasState } from '../index';
import { findTabIndex } from 'utils/section/tabSection.ts';

export interface Payload {
  name: string;
  currentTab: number;
}

export const removeSection = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { name, currentTab } = payload;
  const tabSections = state.tabSections;

  const currentTabIndex = findTabIndex(tabSections, currentTab);

  if (currentTabIndex === -1) throw new Error('Tab index not found');

  if (tabSections.length === 1 && tabSections[currentTabIndex].sections.length === 1) {
    return;
  }

  const updatedTab = {
    ...state.tabSections[currentTabIndex],
    sections: state.tabSections[currentTabIndex].sections.filter((section) => section.name !== name),
  };

  if (updatedTab.sections.length === 0 && state.tabSections.length > 1) {
    const updatedTabs = state.tabSections
      .filter((_, index) => index !== currentTabIndex)
      .map((tab, index) => ({
        ...tab,
        tab: {
          ...tab.tab,
          number: index,
        },
      }));

    return {
      ...state,
      tabSections: updatedTabs,
    };
  }

  return {
    ...state,
    tabSections: state.tabSections.map((tab, index) => (index === currentTabIndex ? updatedTab : tab)),
  };
};
